import { useEffect, useState, useRef } from 'react';
import { noticeAPI } from '../utils/api';
import './NoticeBar.css';

const NoticeBar = () => {
  const [notices, setNotices] = useState([]);
  const textRef = useRef(null);
  const animRef = useRef(null);
  const posRef = useRef(null);
  const pausedRef = useRef(false);

  useEffect(() => {
    noticeAPI.getAll().then(setNotices).catch(() => {});
    const id = setInterval(() => {
      noticeAPI.getAll().then(setNotices).catch(() => {});
    }, 5 * 60 * 1000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const el = textRef.current;
    if (!el || !notices.length) return;
    cancelAnimationFrame(animRef.current);
    const getTrackWidth = () => el.parentElement?.offsetWidth || window.innerWidth;
    posRef.current = getTrackWidth();
    const step = () => {
      if (!pausedRef.current) {
        posRef.current -= 0.6;
        if (posRef.current < -el.offsetWidth) {
          posRef.current = getTrackWidth();
        }
        el.style.transform = `translateX(${posRef.current}px)`;
      }
      animRef.current = requestAnimationFrame(step);
    };
    animRef.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(animRef.current);
  }, [notices]);

  if (!notices.length) return null;

  return (
    <div className="notice-bar">
      <div
        className="notice-bar__track"
        onMouseEnter={() => { pausedRef.current = true; }}
        onMouseLeave={() => { pausedRef.current = false; }}
      >
        <span className="notice-bar__inner" ref={textRef}>
          {notices.map((n, i) => {
            const color = n.color || '#dc2626';
            return (
              <span key={n._id || i} className="notice-bar__item">
                <span className="notice-new-badge" style={{ background: color }}>NEW</span>
                <span className="notice-bar__text" style={{ color, textShadow: '0 1px 6px rgba(0,0,0,0.35)' }}>{n.text}</span>
                {i < notices.length - 1 && <span className="notice-bar__sep" style={{ color }}>•</span>}
              </span>
            );
          })}
        </span>
      </div>
    </div>
  );
};

export default NoticeBar;
